// dopaminash.js — Shopify Theme Scripts

document.addEventListener('DOMContentLoaded', function() {

  // ─── CURSOR (solo desktop) ────────────────────────────────────────────────
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  if (cursor && ring && window.innerWidth > 1024) {
    let rx = 0, ry = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', function(e) {
      cx = e.clientX; cy = e.clientY;
      cursor.style.left = cx + 'px';
      cursor.style.top  = cy + 'px';
    });
    (function raf() {
      rx += (cx - rx) * 0.12;
      ry += (cy - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(raf);
    })();
    document.querySelectorAll('a, button').forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        cursor.style.width = '20px';
        cursor.style.height = '20px';
        cursor.style.background = 'var(--amarillo)';
        ring.style.width = '56px';
        ring.style.height = '56px';
        ring.style.borderColor = 'var(--rosa)';
      });
      el.addEventListener('mouseleave', function() {
        cursor.style.width = '10px';
        cursor.style.height = '10px';
        cursor.style.background = 'var(--rosa)';
        ring.style.width = '38px';
        ring.style.height = '38px';
        ring.style.borderColor = 'var(--negro)';
      });
    });
  }

  // ─── NAV SCROLL ───────────────────────────────────────────────────────────
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ─── SCROLL REVEAL ────────────────────────────────────────────────────────
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) e.target.classList.add('in');
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function(el) {
    observer.observe(el);
  });

});
